import {
  REGISTER_REQUEST,
  REGISTER_SUCCESS,
  REGISTER_FAILURE,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  GET_USER_REQUEST,
  GET_USER_SUCCESS,
  GET_USER_FAILURE,
  LOGOUT,
  GET_ALL_USER_REQUEST,
  GET_ALL_USER_SUCCESS,
  GET_ALL_USER_FAILURE,
} from "./ActionTypes";
import api from "../../config/api";
import humanError from "../../utils/humanError";
import { mergeGuestCart } from "../Customers/Cart/Action";
import { mergeGuestWishlist } from "../../utils/wishlist";

// Register action creators
const registerRequest = () => ({ type: REGISTER_REQUEST });
const registerSuccess = (user) => ({ type: REGISTER_SUCCESS, payload: user });
const registerFailure = (error) => ({ type: REGISTER_FAILURE, payload: error });

export const register = (userData) => async (dispatch) => {
  dispatch(registerRequest());
  try {
    const response = await api.post(`/auth/signup`, userData);
    const user = response.data;
    if (user.jwt) localStorage.setItem("jwt", user.jwt);

    // Anything added before creating the account follows them in.
    if (user.jwt) {
      await dispatch(mergeGuestCart());
      await mergeGuestWishlist();
    }

    dispatch(registerSuccess(user));
  } catch (error) {
    dispatch(
      registerFailure(
        humanError(error, "Could not create your account. Please try again.")
      )
    );
  }
};

// Login action creators
const loginRequest = () => ({ type: LOGIN_REQUEST });
const loginSuccess = (user) => ({ type: LOGIN_SUCCESS, payload: user });
const loginFailure = (error) => ({ type: LOGIN_FAILURE, payload: error });

export const login = (userData) => async (dispatch) => {
  dispatch(loginRequest());
  try {
    const response = await api.post(`/auth/signin`, userData);
    const user = response.data;
    if (user.jwt) localStorage.setItem("jwt", user.jwt);

    // Merge the guest cart BEFORE reporting success, so the first cart fetch
    // after sign-in already includes those items.
    if (user.jwt) {
      await dispatch(mergeGuestCart());
      await mergeGuestWishlist();
    }

    dispatch(loginSuccess(user));
  } catch (error) {
    dispatch(
      loginFailure(
        humanError(error, "Could not sign you in. Please check your details and try again.")
      )
    );
  }
};

//  get user from token
export const getUser = (token) => {
  return async (dispatch) => {
    dispatch({ type: GET_USER_REQUEST });
    try {
      const response = await api.get(`/api/users/profile`);
      const user = response.data;
      dispatch({ type: GET_USER_SUCCESS, payload: user });
      
    } catch (error) {
      const errorMessage = humanError(error);
      dispatch({ type: GET_USER_FAILURE, payload: errorMessage });
    }
  };
};

export const logout = (token) => {
  return async (dispatch) => {
    dispatch({ type: LOGOUT });
    localStorage.clear();
  };
};

//  get all users (admin only). role: "" (customers, default) | "ADMIN" | "all"
export const getAllUsers = (role = "") => {
  return async (dispatch) => {
    dispatch({ type: GET_ALL_USER_REQUEST });
    try {
      const response = await api.get(
        `/api/users${role ? `?role=${role}` : ""}`
      );
      const users = response.data;

      dispatch({ type: GET_ALL_USER_SUCCESS, payload: users });
    } catch (error) {
      const errorMessage = humanError(error);
      dispatch({ type: GET_ALL_USER_FAILURE, payload: errorMessage });
    }
  };
};

//  update a user's role (admin only) — refreshes the user list on success
export const updateUserRole = (userId, role) => {
  return async (dispatch) => {
    try {
      await api.put(`/api/users/${userId}/role`, { role });
      dispatch(getAllUsers());
    } catch (error) {
      dispatch({
        type: GET_ALL_USER_FAILURE,
        payload: error.response?.data?.error || "Something went wrong. Please try again.",
      });
    }
  };
};

//  block / unblock a customer (admin only)
export const setUserActive = (userId, isActive) => {
  return async (dispatch) => {
    try {
      await api.put(`/api/users/${userId}/active`, { isActive });
      dispatch(getAllUsers());
    } catch (error) {
      dispatch({
        type: GET_ALL_USER_FAILURE,
        payload: error.response?.data?.error || "Something went wrong. Please try again.",
      });
    }
  };
};

//  delete a customer (admin only)
export const deleteUser = (userId) => {
  return async (dispatch) => {
    try {
      await api.delete(`/api/users/${userId}`);
      dispatch(getAllUsers());
    } catch (error) {
      dispatch({
        type: GET_ALL_USER_FAILURE,
        payload: error.response?.data?.error || "Something went wrong. Please try again.",
      });
    }
  };
};
